import Vue from 'vue'

const KyeExpandPage = Vue.component('kye-expand-page', {
  functional: true,
  render (h, self) {
    let directives = self.data.directives || []
    // 2022-09-22 增加页面最大宽度
    let xl = self.props.xl || false
    self.data.directives = [...directives, { name: 'next' }]
    return h('div', { ...self.data, attrs: { class: `kye-expand-page ${xl ? 'kye-expand-xl-page' : ''}` } }, self.children)
  }
})

export default KyeExpandPage



// WEBPACK FOOTER //
// ./src/public/components/kye-expand-page/index.js